// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getDestinos as listDestinosAPI,
    getDestino as getDestinoAPI,
    addDestino as addDestinoAPI,
    updateDestino as updateDestinoAPI,
    deleteDestino as deleteDestinoAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { destinosApiResponseError, destinosApiResponseSuccess } from './actions';
import { DestinosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getDestino({ payload: { id } }) {
    try {
        const response = yield call(getDestinoAPI, id );
        const destinoItem = response.data.data;
        yield put(destinosApiResponseSuccess(DestinosActionTypes.GET_DESTINO, destinoItem));
    } catch (error) {
        yield put(destinosApiResponseError(DestinosActionTypes.GET_DESTINO, error));
    }
}

function* addDestino({payload:destino}) {
    try{
        const response = yield call(addDestinoAPI,{...destino})
        const destinoItem = response.data
        yield put(destinosApiResponseSuccess(DestinosActionTypes.ADD_DESTINO,destinoItem))
    } catch(error){
        yield put(destinosApiResponseError(DestinosActionTypes.ADD_DESTINO,error))
    }
}

function* updateDestino({payload:destino}){
    try{
        const response = yield call(updateDestinoAPI,{...destino})
        const destinoItem = response.data.data
        yield put(destinosApiResponseSuccess(DestinosActionTypes.UPDATE_DESTINO,destinoItem))
    }catch(error){
        yield put(destinosApiResponseError(DestinosActionTypes.UPDATE_DESTINO,error))
    }
}
function* deleteDestino({payload:{id}}){
    try{
        const response = yield call(deleteDestinoAPI,id)
        const destinoItem = response.data.id
        yield put(destinosApiResponseSuccess(DestinosActionTypes.DELETE_DESTINO,destinoItem))
    }catch(error){
        yield put(destinosApiResponseError(DestinosActionTypes.DELETE_DESTINO,error))
    }
}

/**
 * List contactos
 */
function* listDestinos({payload:params}) {
    try {
        const response = yield call(listDestinosAPI, { ...params });
        const listaDestinos = response.data.data;
        yield put(destinosApiResponseSuccess(DestinosActionTypes.LIST_DESTINOS, listaDestinos));
    } catch (error) {
        yield put(destinosApiResponseError(DestinosActionTypes.LIST_DESTINOS, error));
    }
}

export function* watchGetDestino(): any {
    yield takeEvery(DestinosActionTypes.GET_DESTINO, getDestino);
}

export function* watchListDestinos(): any {
    yield takeEvery(DestinosActionTypes.LIST_DESTINOS, listDestinos);
}

export function* watchAddDestino():any{
    yield takeEvery(DestinosActionTypes.ADD_DESTINO,addDestino)
}
export function* watchUpdateDestino():any{
    yield takeEvery(DestinosActionTypes.UPDATE_DESTINO,updateDestino)
}
export function* watchDeleteDestino():any{
    yield takeEvery(DestinosActionTypes.DELETE_DESTINO,deleteDestino)
}


function* destinosSaga(): any {
    yield all([
        fork(watchGetDestino),
        fork(watchListDestinos),
        fork(watchAddDestino),
        fork(watchUpdateDestino),
        fork(watchDeleteDestino),
    ]);
}

export default destinosSaga;
